<template>
  <div class="fill-height error-container">
    <v-row
      align="center"
      justify="center"
      class="fill-height ma-0"
    >
      <v-col 
        cols="12" 
        :sm="10" 
        :md="12"
        :lg="12" 
        :xl="12"
        class="pa-0"
      >
        <div 
          class="error-card-wrapper text-center"
          :class="$vuetify.breakpoint.xsOnly ? 'mobile-wrapper' : 'desktop-wrapper'"
        >
          <!-- Icon Section -->
          <div class="error-icon-section">
            <div class="icon-wrapper">
              <v-icon 
                :size="$vuetify.breakpoint.xsOnly ? 64 : 
                  $vuetify.breakpoint.smOnly ? 80 : 
                  $vuetify.breakpoint.mdOnly ? 90 : 100"
                color="warning"
                class="error-icon"
              >
                mdi-cash-register-variant
              </v-icon>
            </div>
          </div>
          
          <!-- Title Section -->
          <div class="title-section">
            <h1 :class="$vuetify.breakpoint.xsOnly ? 'text-h4' : 'text-h3'">
              No Outlet Available
            </h1>
          </div>
          
          <!-- Content Section -->
          <div class="content-section">
            <p class="primary-message">
              {{ $vuetify.breakpoint.xsOnly ? 
                'No outlets are configured for this hotel.' :
                'There are currently no outlets configured for this hotel.' }}
            </p>
            
            <p class="secondary-message">
              {{ $vuetify.breakpoint.xsOnly ?
                'An outlet must be set up to access the POS system.' :
                'To access the Point of Sale system, at least one outlet must be configured and assigned to this hotel.' }}
            </p>
          </div>
          
          <!-- Mobile Actions -->
          <div 
            v-if="$vuetify.breakpoint.xsOnly"
            class="mobile-actions"
          >
            <v-btn 
              color="primary" 
              @click="contactSupport"
              class="mb-3"
              block
              large
              rounded
              depressed
            >
              <v-icon left>
                mdi-email
              </v-icon>
              Contact Support
            </v-btn>
            
            <v-btn 
              color="grey lighten-1" 
              @click="refreshPage"
              text
              large
              rounded
            >
              <v-icon left>
                mdi-refresh
              </v-icon>
              Refresh
            </v-btn>
          </div>

          <!-- Desktop Actions -->
          <div
            v-else
            class="desktop-actions"
          >            
            <v-btn 
              color="primary" 
              @click="contactSupport"
              large
              rounded
              depressed
              class="action-btn"
            >
              <v-icon left>
                mdi-email
              </v-icon>
              Contact Support
            </v-btn>
            
            <v-btn 
              color="grey lighten-1" 
              @click="refreshPage"
              large
              text
              rounded
              class="action-btn"
            >
              <v-icon left>
                mdi-refresh
              </v-icon>
              Refresh Page
            </v-btn>
          </div>
          
          <!-- Support Info -->
          <div class="support-info">
            <v-chip
              small
              color="blue-grey lighten-4"
              text-color="blue-grey darken-2"
            >
              <v-icon
                left
                small
              >
                mdi-email
              </v-icon>
              support-pms@sentineltech.com
            </v-chip>
          </div>
          
          <!-- Debug Info -->
          <div 
            v-if="$route.query.hotelId"
            class="debug-info"
          >
            <v-chip
              x-small
              color="info"
              text-color="white"
            >
              <v-icon
                left
                x-small
              >
                mdi-information
              </v-icon>
              Hotel ID: {{ $route.query.hotelId }}
            </v-chip>
          </div>
        </div>
        
        <!-- Additional Help Text for Desktop -->
        <div 
          v-if="$vuetify.breakpoint.lgAndUp" 
          class="additional-help"
        >
          <p>
            <v-icon
              small
              color="grey"
            >
              mdi-information-outline
            </v-icon>
            This usually means the hotel setup is incomplete. Our support team can help resolve this quickly.
          </p>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true
    };
  },
  computed: {
    isPageLoading: function() {
      return this.$store.state.app.isPageLoading;
    }
  },
  mounted() {
    const self = this;
    setTimeout(function (){
      self.loading = false;
    }, 1000); 
  },
  methods: {
    contactSupport() {
      const subject = encodeURIComponent("POS Outlet Configuration Issue");
      const body = encodeURIComponent(`Hello,

I am experiencing an issue with the POS system where no outlets are configured for Hotel ID: ${this.$route.query.hotelId || "Unknown"}.

Please help me resolve this issue so I can access the Point of Sale system.

Thank you,`);
      
      const mailtoLink = `mailto:support-pms@sentineltech.com?subject=${subject}&body=${body}`;
      window.location.href = mailtoLink;
    },
    
    refreshPage() {
      window.location.reload();
    }
  }
};
</script>

<style scoped>
.error-container {
  background: #f8f9fa;
  min-height: 100vh;
  position: relative;
  width: 100%;
}

.error-card-wrapper {
  background: white;
  position: relative;
  z-index: 1;
}

.mobile-wrapper {
  padding: 24px 20px;
  margin: 16px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.desktop-wrapper {
  padding: 80px 120px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}


.error-icon-section {
  margin-bottom: 24px;
}

.icon-wrapper {
  position: relative;
  display: inline-block;
}

.error-icon {
  background: linear-gradient(135deg, #ff7043 0%, #ff5722 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: iconPulse 2s ease-in-out infinite;
  filter: drop-shadow(0 4px 8px rgba(255, 112, 67, 0.3));
}

@keyframes iconPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

.title-section {
  margin-bottom: 20px;
}

.title-section h1 {
  font-weight: 700;
  color: #2c3e50;
  line-height: 1.2;
  margin: 0;
}

.content-section {
  margin-bottom: 28px;
}

.primary-message {
  font-size: 18px;
  font-weight: 500;
  color: #34495e;
  margin-bottom: 16px;
  line-height: 1.5;
}

.secondary-message {
  font-size: 16px;
  color: #7f8c8d;
  line-height: 1.6;
  margin-bottom: 0;
}

.mobile-actions {
  margin-bottom: 24px;
}

.desktop-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-bottom: 24px;
}

.action-btn {
  font-weight: 600;
  letter-spacing: 0.5px;
  min-width: 140px;
  transition: all 0.2s ease;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.support-info {
  margin-bottom: 16px;
}

.debug-info {
  margin-bottom: 8px;
}

.additional-help {
  text-align: center;
  margin-top: 32px;
  opacity: 0.8;
}

.additional-help p {
  color: #6c757d;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 0;
}

/* Mobile-specific adjustments */
@media (max-width: 599px) {
  .error-container {
    background: #f8f9fa;
    padding: 0;
  }
  
  .primary-message {
    font-size: 16px;
  }
  
  .secondary-message {
    font-size: 14px;
  }
  
  .v-btn--block {
    height: 48px !important;
    font-size: 16px;
    font-weight: 600;
  }
}

/* Tablet adjustments */
@media (min-width: 600px) and (max-width: 959px) {
  .desktop-wrapper {
    padding: 60px 40px;
    margin: 20px;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    min-height: auto;
  }
}

/* Desktop adjustments */
@media (min-width: 960px) {
  .desktop-wrapper {
    padding: 80px 100px;
  }
  
  .error-icon-section {
    margin-bottom: 40px;
  }
  
  .title-section {
    margin-bottom: 32px;
  }
  
  .title-section h1 {
    font-size: 2.5rem;
  }
  
  .content-section {
    margin-bottom: 40px;
  }
  
  .primary-message {
    font-size: 20px;
    margin-bottom: 20px;
  }
  
  .secondary-message {
    font-size: 18px;
  }
  
  .desktop-actions {
    margin-bottom: 40px;
    gap: 20px;
  }
  
  .action-btn {
    min-width: 180px;
    padding: 0 32px;
  }
}

/* Large desktop adjustments */
@media (min-width: 1264px) {
  .desktop-wrapper {
    padding: 100px 160px;
  }
  
  .title-section h1 {
    font-size: 3rem;
  }
  
  .primary-message {
    font-size: 22px;
  }
  
  .secondary-message {
    font-size: 19px;
  }
  
  .action-btn {
    min-width: 220px;
    padding: 0 40px;
  }
}

/* Dark theme support */
.theme--dark .error-container {
  background: #2c2c34;
}

.theme--dark .error-card-wrapper {
  background: #2c2c34 !important;
}

.theme--dark .title-section h1 {
  color: #ecf0f1;
}

.theme--dark .primary-message {
  color: #bdc3c7;
}

.theme--dark .secondary-message {
  color: #95a5a6;
}

/* Animation delays for staggered entrance */
.error-icon-section {
  animation: fadeInUp 0.6s ease-out;
}

.title-section {
  animation: fadeInUp 0.6s ease-out 0.1s both;
}

.content-section {
  animation: fadeInUp 0.6s ease-out 0.2s both;
}

.mobile-actions,
.desktop-actions {
  animation: fadeInUp 0.6s ease-out 0.3s both;
}

.support-info {
  animation: fadeInUp 0.6s ease-out 0.4s both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
